import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";

export default function AdminRoute({ component: Component, ...restProps }) {
  const { authState } = useAuth();

  if (authState?.processing) return null;
  return <Route {...restProps} render={props => authState.isAuthenticated ? <Component {...props} /> : <Redirect to="/admin" />} />
}